var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1BACE4",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.485,
    d: "M17.6293538 22.8095988L2.30032235 22.8095988 8.97764846 1.44019317C9.10899512 1.02221883 9.51006744.736204518 9.96483809.736204518 10.4196087.736204518 10.8206811 1.02221883 10.9520277 1.44019317L17.6293538 22.8095988zM6.89903179 8.09372862L13.0306444 8.09372862M5.9792899 11.0369027L13.9503863 11.0369027M4.59967707 15.4516637L15.3299991 15.4516637M3.67993518 18.3948378L16.249741 18.3948378M.000967625648 22.8095988L19.9287086 22.8095988",
    transform: "translate(10 8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.b759c5c0a4f6a190aa3e29c490b68783.svg";
export { ForwardRef as ReactComponent };